import { render, staticRenderFns } from "./JornadaLaboral.vue?vue&type=template&id=4959cb87&"
import script from "./JornadaLaboral.vue?vue&type=script&lang=js&"
export * from "./JornadaLaboral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports